import type { PageRoute, ParentPageRoute } from './AppPageRoutesWithTelemetry.types';

export const isParentRoute = (route: PageRoute | ParentPageRoute): route is ParentPageRoute => !!route.childRoutes;
